import React, { useState } from "react";
import { Col, Input, Modal, Row, Form, message, notification } from "antd";
import strings from "../../utils/Localization";
import { api } from "../../helpers/ApiHelper";
import BankaSelectOption from "../toolbox/BankaSelectOption";
import DovizSelectOption from "../toolbox/DovizSelectOption";
import { useDispatch } from "react-redux";
import { setRerender } from "../../redux/actions/rerenderAction";

const formSize = "middle";

function BankaHesapEkleModal({ visible = false, handleCancel }) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { bankaHesapEkleModal: localization } = strings.bankaHesap;

  const onFinish = async (values) => {
    try {
      const { hesapAdi, bankaId, dovizId, ibanNo, sube, subeNo, hesapNo } =
        values;

      setFetchLoading(true);
      const response = await api.post("/bankahesap", {
        BankaId: bankaId,
        DovizId: dovizId,
        Ad: hesapAdi,
        Sube: sube,
        SubeNo: subeNo,
        HesapNo: hesapNo,
        IbanNo: ibanNo,
      });
      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        form.resetFields();
        dispatch(setRerender());
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Modal
      title={localization.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: "submit",
        form: "bankaHesapModalEkle",
        size: formSize,
        loading: fetchLoading,
      }}
      cancelButtonProps={{ size: formSize }}
      width="50%"
      centered
    >
      <Form
        name="bankaHesapModalEkle"
        onFinish={onFinish}
        form={form}
        layout="vertical"
        size={formSize}
      >
        <Row gutter={24}>
          <Col xl={12}>
            <Form.Item
              name="hesapAdi"
              label={localization.hesapAdi}
              rules={[{ required: true }]}
            >
              <Input placeholder={localization.hesapAdiPlaceHolder} />
            </Form.Item>
            <BankaSelectOption formItemName="bankaId" />
            <DovizSelectOption formItemName="dovizId" required />
            <Form.Item name="ibanNo" label={localization.ibanNo}>
              <Input placeholder={localization.ibanNoPlaceHolder} />
            </Form.Item>
          </Col>
          <Col xl={12}>
            <Form.Item name="sube" label={localization.sube}>
              <Input placeholder={localization.subePlaceHolder} />
            </Form.Item>
            <Form.Item name="subeNo" label={localization.subeNo}>
              <Input placeholder={localization.subeNoPlaceHolder} />
            </Form.Item>
            <Form.Item name="hesapNo" label={localization.hesapNo}>
              <Input placeholder={localization.hesapNoPlaceHolder} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default BankaHesapEkleModal;
